import { useEffect, useState } from "react";
import { api } from "@/lib/leuteliaApi";
import { TrendingUp, TrendingDown, Minus, Sparkles, History } from "lucide-react";

const V = { migliora: ["Migliora", "text-emerald-800 bg-emerald-50 border-emerald-300", TrendingUp], peggiora: ["Peggiora", "text-red-800 bg-red-50 border-red-300", TrendingDown], stabile: ["Stabile", "text-brand-ink bg-stone-50 border-stone-300", Minus], "prima analisi": ["Prima analisi", "text-amber-800 bg-amber-50 border-amber-300", Sparkles] };
const d8 = (iso) => new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit" });

function Spark({ points }) {
  if (points.length < 2) return null;
  const w = 120, h = 34, xs = points.map((_, i) => (i / (points.length - 1)) * (w - 6) + 3), ys = points.map((p) => h - 3 - ((p.score || 0) / 10) * (h - 6));
  return <svg width={w} height={h} className="shrink-0" aria-hidden><polyline fill="none" stroke="#16493A" strokeWidth="1.8" points={xs.map((x, i) => `${x},${ys[i]}`).join(" ")} />{xs.map((x, i) => <circle key={i} cx={x} cy={ys[i]} r="2.2" fill={i === xs.length - 1 ? "#C6902A" : "#16493A"} />)}</svg>;
}

// Confronto prima/dopo: voti medi dei moduli a ogni analisi (solo analisi realmente eseguite).
export default function ConfrontoVoti({ scope }) {
  const [h, setH] = useState(null);
  useEffect(() => { let on = true; api.deepHistory(scope.tenant, scope.hotel).then((r) => on && setH(r)).catch(() => on && setH({ modules: [] })); return () => { on = false; }; }, [scope.tenant, scope.hotel]);
  if (!h || !h.modules.length) return null;
  const withPrev = h.modules.filter((m) => m.previous != null);
  return (
    <div className="bg-white rounded-xl border border-brand-gold/25 p-5" data-testid="confronto-voti">
      <div className="flex items-start gap-2.5">
        <History size={20} className="text-brand-gold mt-0.5" strokeWidth={1.9} />
        <div className="flex-1">
          <h3 className="font-serif text-[20px] text-brand-ink leading-none">Prima e dopo: i voti dei moduli</h3>
          <p className="text-[12.5px] text-brand-muted mt-1">{withPrev.length ? `${withPrev.length} modul${withPrev.length === 1 ? "o" : "i"} con almeno due analisi a confronto.` : "Per ora c'è una sola analisi per modulo: il confronto comparirà dalla prossima rianalisi."} {h.note}</p>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
        {h.modules.map((m) => { const [l, cls, Icon] = V[m.verdict]; return (
          <div key={m.module} className={`rounded-lg border p-3 ${cls}`} data-testid={`confronto-voti-${m.module}`}>
            <div className="flex items-center gap-2"><Icon size={14} /><span className="text-[10.5px] font-bold uppercase tracking-wide">{l}</span>
              <span className="ml-auto font-serif text-[20px]" data-testid={`confronto-voti-last-${m.module}`}>{m.last}<span className="text-[11px] opacity-70">/10</span></span></div>
            <div className="font-semibold text-[13.5px] mt-1">{m.label}</div>
            <div className="flex items-end justify-between gap-2 mt-1">
              <div className="text-[11.5px] opacity-80">{m.previous != null ? <>Prima {m.previous}/10 ({d8(m.previous_at)}) → ora {m.last}/10 ({d8(m.last_at)}): <strong>{m.delta > 0 ? "+" : ""}{m.delta}</strong></> : <>Analizzato il {d8(m.last_at)}: nessun confronto ancora</>}</div>
              <Spark points={m.points} />
            </div>
          </div>); })}
      </div>
    </div>
  );
}
